module.exports = __webpack_public_path__ + "img/session.250d7917.svg";